import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

/** The legacy enum's labels, so a seeded type reads the same as it did before
 * client-defined types. */
const SYSTEM_KEY_NAME: Record<string, MessageDescriptor> = {
  VACATION: msg`Dopust`,
  SICK_LEAVE: msg`Bolniška`,
  OTHER: msg`Drugo`,
  BREAK: msg`Odmor`,
  LUNCH: msg`Malica`,
  WALK_IN: msg`Sprejem strank`,
};

/**
 * The seeded type's own translated name, whatever the client renamed it to —
 * the only way to tell which default a renamed type is.
 */
export function resolveDefaultTimeOffTypeName(systemKey: string): string {
  if (systemKey in SYSTEM_KEY_NAME) {
    return i18n._(SYSTEM_KEY_NAME[systemKey]);
  }
  return systemKey;
}

/**
 * `name ?? t(systemKey)` (design decision 12): a seeded type stays translated
 * per locale until a client renames it, at which point their string wins —
 * until they clear the name again. An unrecognised systemKey (shouldn't
 * happen, but cheaper than a throw) falls back to the raw key rather than an
 * empty string.
 */
export function resolveTimeOffTypeName(type: {
  name: string | null;
  systemKey: string | null;
}): string {
  if (type.name) return type.name;
  if (type.systemKey) return resolveDefaultTimeOffTypeName(type.systemKey);
  return "";
}
